import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import "./my-account.m.css";
import { Link } from "@quintype/components";
import { setIsLogin, setUserDetails, setVerifyUser } from "../../store/actions";
import { googleLogout } from "@react-oauth/google";
import MyProfile from "./my-profile";
import SavedArticles from "./saved-articles";
import { get } from "lodash";
import { addLogoutToDataLayer } from "../../helper/datalayer-utils";
import User from "../../atoms/other-icons/User";
import Signout from "../../atoms/other-icons/Signout";
import Close from "../../atoms/other-icons/Close";

function MyAccount({ closeModal }) {
  const dispatch = useDispatch();
  const ssoEndpoint = useSelector((state) =>
    get(state, ["qt", "config", "publisher-attributes", "sso_endpoint"], null)
  );
  const [isDropdownCollapsed, setIsDropdownCollapsed] = useState("myprofile");
  const [redirectUrl, setRedirectUrl] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const userdetails = useSelector((state) => get(state, ["user", "user"], {}));

  useEffect(() => {
    if (window) {
      const url = window.location.href.split("?")[0];
      setRedirectUrl(url);
    }
  }, []);

  useEffect(() => {
    if (userdetails?.userData?.id) {
      setIsLoading(false);
    }
  }, [userdetails?.userData?.id]);

  const onDropdownBtnHandler = (value) => {
    if (value === isDropdownCollapsed) {
      setIsDropdownCollapsed("");
    } else {
      setIsDropdownCollapsed(value);
    }
  };

  const logoutHandler = () => {
    addLogoutToDataLayer(window.location.href, userdetails);
    window.localStorage.removeItem("user");
    window.localStorage.removeItem("access_token");
    window.localStorage.removeItem("refresh_token");
    localStorage.removeItem("commentsToken");
    window.location.search = "";
    googleLogout();
    dispatch(setIsLogin(false));
    closeModal();
  };
  if (isLoading)
    return (
      <div styleName="loading-animation">
        <div styleName="loading-animation__circle"></div>
      </div>
    );

  return (
    <div styleName="my-account-wrapper">
      <div styleName="close-btn-wrapper" onClick={closeModal}>
        <Close color="black" height="10" width="10" />
      </div>
      {/* <p styleName="user-mail-id">{email}</p> */}
      <div styleName={`my-account-detail-container ${isDropdownCollapsed === "myprofile" ? "collapsed" : "close"}`}>
        <div
          styleName={`title ${isDropdownCollapsed === "myprofile" ? "title-bg" : ""}`}
          // onClick={() => onDropdownBtnHandler("myprofile")}
        >
          <span styleName="title-text">My Profile</span>
        </div>
        {isDropdownCollapsed === "myprofile" && <MyProfile />}
      </div>

      <button
        styleName="logout-btn"
        onClick={() => {
          logoutHandler();
        }}
      >
        <Link href={`${ssoEndpoint}/auth/logout?redirectUrl=${redirectUrl}`}>
          <Signout color="#0091ac" width="16px" height="16px" /> Log Out
        </Link>
      </button>
    </div>
  );
}

export default MyAccount;
